import { render, staticRenderFns } from "./NewYachtSpecifications.vue?vue&type=template&id=77785be9&scoped=true&"
import script from "./NewYachtSpecifications.vue?vue&type=script&lang=js&"
export * from "./NewYachtSpecifications.vue?vue&type=script&lang=js&"
import style0 from "./NewYachtSpecifications.vue?vue&type=style&index=0&id=77785be9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77785be9",
  null
  
)

export default component.exports